module.exports = __webpack_public_path__ + "img/welding4.a8a246ad.png";